const bumpButtons = '[data-admin-bump-button]';

function bindButtonAjax() {
  $(document).on('ajax:success', bumpButtons, function (_e, xhr) {
    const button = $(this);
    button.replaceWith(xhr);
  });
  $(document).on('ajax:error', bumpButtons, function (xhr, status, error) {
    const button = $(this);
    button.replaceWith('Error');
  });
}

export default {
  init: bindButtonAjax,
};
